import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const VatNumberModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "VatNumberModalContainer" */
      './VatNumberModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
